<template>
    <basic-container>
        <avue-crud :option="option"
                   :table-loading="loading"
                   :data="data"
                   :page.sync="page"
                   :search.sync="searchForm"
                   :permission="permissionList"
                   :before-open="beforeOpen"
                   :before-close="beforeClose"
                   v-model="form"
                   ref="crud"
                   @row-update="rowUpdate"
                   @row-save="rowSave"
                   @row-del="rowDel"
                   @search-change="searchChange"
                   @search-reset="searchReset"
                   @selection-change="selectionChange"
                   @current-change="currentChange"
                   @size-change="sizeChange"
                   @on-load="onLoad"
                   @refresh-change="onLoad"
        >
            <template slot="menuLeft">
                <el-button type="danger"
                           size="small"
                           icon="el-icon-delete"
                           plain
                           v-if="permission.commonusedphone_delete"
                           @click="handleDelete">删 除
                </el-button>
            </template>
        </avue-crud>
    </basic-container>
</template>

<script>
    import {add, getDetail, getList, remove, update} from "@/api/crmedical/common/usedphone/commonusedphone";
    import {mapGetters} from "vuex";
        import {
            getProjectList,
        } from "@/api/crmedical/device/taskManagement.js"
    export default {
        data() {
            return {
                form: {},
                searchForm:{},
                query: {},
                loading: false,
                page: {
                    pageSize: 10,
                    currentPage: 1,
                    total: 0
                },
                selectionList: [],
                option: {
                        height: 'auto',
                        calcHeight: 350,
                        tip: false,
                        border: true,
                        index: true,
                        viewBtn: true,
                        searchMenuSpan:12,
                        selection: true,
                        stripe:true,
                        dialogClickModal:false,
                        dialogWidth:"50%",
                    column: [

                                {
                                    label: "项目名称",
                                    prop: "projectId",
                                    type:"select",
                                    search:true,
                                    searchSpan:6,
                                    rules: [{
                                        required: true,
                                        message: "请选择项目名称",
                                        trigger: "change"
                                    }],
                                    dicData:[],
                                    props:{
                                            label:'name',
                                            value:'id'
                                    },
                                },
                                {
                                    label: "名称",
                                    prop: "name",
                                //     search:true,
                                    searchSpan:6,
                                    maxlength:20,
                                    showWordLimit:true,
                                    rules: [{
                                        required: true,
                                        message: "请输入名称",
                                        trigger: "change"
                                    }]
                                },
                                {
                                    label: "名称",
                                    prop: "name2",
                                    showColumn:false,
                                    search:true,
                                    searchSpan:6,
                                    display:false,
                                },
                                {
                                    label: "联系电话",
                                    prop: "mobile",
                                    maxlength:20,
                                    showWordLimit:true,
                                    rules: [{
                                        required: true,
                                        message: "请输入联系电话",
                                        trigger: "change"
                                    }]
                                },
                        ]
                },
                data: [],
                passCloseDialog:false,
                temProjectId:'',
            };
        },
        computed: {
            ...mapGetters(["permission"]),
            permissionList() {
                return {
                    addBtn: this.vaildData(this.permission.commonusedphone_add, false),
                    viewBtn: this.vaildData(this.permission.commonusedphone_view, false),
                    delBtn: this.vaildData(this.permission.commonusedphone_delete, false),
                    editBtn: this.vaildData(this.permission.commonusedphone_edit, false)
                };
            },
            ids() {
                let ids = [];
                this.selectionList.forEach(ele => {
                    ids.push(ele.id);
                });
                return ids.join(",");
            }
        },
        created(){
                this.initData();
                this.$nextTick(() => {
                setTimeout(()=>{
                        this.$refs.crud.$children[1].$children[4].$el.addEventListener("click", ()=>{

                                if(this.option.height == this.bodyHeight - 338){
                                this.option.height = this.bodyHeight - 274
                                }else{
                                this.option.height = this.bodyHeight - 338;
                                }
                                this.$refs.crud.getTableHeight();
                                });
                        })

                });
                this.option.height = this.bodyHeight - 338;
        },
        beforeRouteEnter (to, from, next) {
            next(vm => {
                // 通过 `vm` 访问组件实例
                vm.$refs.crud.$refs.table.doLayout();
            })
        },
        methods: {
                // 初始化数据
                async initData(){
                        let projectColumn = this.findObject(this.option.column,'projectId');
                        // 获取项目
                        await getProjectList().then(res=>{
                                this.projectList = res.data;
                                projectColumn.dicData = res.data;
                                this.searchForm.projectId = this.projectList[0]?this.projectList[0].id:'';
                                this.query.projectId = this.projectList[0]?this.projectList[0].id:'';
                                this.onLoad();
                        })

                },
                beforeClose(done, type) {
                        if(this.passCloseDialog){
                                done();
                        }else{
                                this.$confirm("确定关闭页面?", {
                                        confirmButtonText: "确定",
                                        cancelButtonText: "取消",
                                        type: "warning"
                                })
                                .then(() => {


                                        done();
                                })
                                .then(() => {

                                });
                        }

                },
            rowSave(row, loading, done) {

                add(row).then(() => {
                        this.passCloseDialog = true;
                    loading();
                    this.onLoad();
                    this.$message.success('操作成功!');
                }, error => {
                    done();
                    console.log(error);
                });
            },
            rowUpdate(row, index, loading, done) {
                update(row).then(() => {
                        this.passCloseDialog = true;
                    loading();
                    this.onLoad();
                    this.$message.success('操作成功!');
                }, error => {
                    done();
                    console.log(error);
                });
            },
            rowDel(row) {
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: row.id});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                    });
            },
            handleDelete() {
                if (this.selectionList.length === 0) {
                    this.$message.warning("请选择至少一条数据");
                    return;
                }
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: this.ids});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                        this.$refs.crud.toggleSelection();
                    });
            },
            beforeOpen(done, type) {
                if (["edit", "view"].includes(type)) {
                    getDetail({id:this.form.id}).then(({data}) => {
                        this.form = data;
                    });
                }else{
                        this.form = {
                            projectId:this.temProjectId
                        };
                }
                if (type === 'view') {
                        this.viewFlag = true;
                        this.passCloseDialog = true;
                }else{
                        this.passCloseDialog = false;
                }
                done();
            },
            searchReset() {
                this.query = {};
                this.searchForm= {};
                this.searchForm.projectId = this.temProjectId;
                this.query.projectId = this.temProjectId;
                this.onLoad();
            },
            searchChange(params,done) {
                this.query = params;
                this.page.currentPage = 1;
                this.onLoad();
                done();
            },
            selectionChange(list) {
                this.selectionList = list;
            },
            selectionClear() {
                this.selectionList = [];
                this.$refs.crud.toggleSelection();
            },
            currentChange(currentPage) {
                this.page.currentPage = currentPage;
            },
            sizeChange(pageSize) {
                this.page.pageSize = pageSize;
            },
            onLoad(page) {
                page = page || this.page;
                if(!this.query.projectId){
                        return;
                }
                this.loading = true;
                this.temProjectId = this.query.projectId;
                this.query.name = this.query.name2;
                getList(
                    Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
                ).then(({data}) => {
                    this.page.total = data.total;
                    this.data = data.records;
                    this.loading = false;
                    this.selectionClear();
                });
            }
        }
    };
</script>

<style scoped>

  ::v-deep .avue-form__menu--center{
    text-align: right;
  }
::v-deep   .avue-crud__search .el-form-item--small.el-form-item{
    width: 100%;
  }
</style>
